export const formatCurrency = (value) => {
  const num = parseFloat(String(value).replace(/[£,]/g, ""));
    const absNum = Math.abs(num).toLocaleString("en-UK", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return isNaN(num) ? "£0.00" : `${num < 0 ? "- " : ""}£${absNum}`;
};
